<template>
  <div
    role="button"
    class="bg-background-neutral-secondary flex min-w-0 flex-1 items-center gap-1 rounded-2xl py-3 pl-4 pr-3"
    @click="emit('onInputClick')"
  >
    <div class="flex min-w-0 flex-1 flex-col justify-center">
      <p class="text-text-neutral-quaternary text-xs leading-[18px]">
        {{ $t('general.passengers') }}
      </p>
      <p
        class="text-text-neutral-primary truncate text-base font-semibold leading-[22px]"
      >
        {{ passengersAmountText }}, {{ cabinClassText }}
      </p>
    </div>
    <PersonIcon class="text-text-positive-primary h-5 w-5 shrink-0" />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { passengersTextModel } from 'shared';
  import type { CabinClass, Passengers } from 'shared';

  import PersonIcon from '@/assets/images/person-icon.svg?component';

  const props = defineProps<{
    isYouth: boolean;
    passengers: Passengers;
    cabinClass: CabinClass;
    source: string;
  }>();

  const emit = defineEmits<{
    onInputClick: [];
  }>();

  const passengersText = passengersTextModel.usePassengersText();

  const passengersAmountText = computed(() =>
    passengersText.getPassengersAmountText(props.passengers, props.isYouth),
  );

  const cabinClassText = computed(() =>
    passengersText.getCabinClassText(props.cabinClass, props.isYouth),
  );
</script>
